<template>
  <div class="content background1" style="display: flex">
    <div class="tableBox9" v-if="!qrCodeShow">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane :label="$t('label_429')" name="first">
                <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
            <el-tab-pane :label="$t('label_161')" name="second">
                <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
    <div class="tableBox10" style="overflow: hidden" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
      <div class="alarm-info">
        <div class="box2">
			<div style="display: flex;align-items: center">
				<div>
				  <svg t="1689148646573" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
				       p-id="2326" width="50" height="50">
				    <path
				      d="M768 640h-85.333333v-128h213.333333v128h-85.333333v128h-42.666667v-128z m-213.333333-170.666667v128H128v-128h426.666667z m0 298.666667H128v-128h426.666667v128z m341.333333-341.333333H128V298.666667h768v128zM213.333333 341.333333v42.666667h42.666667V341.333333H213.333333z m85.333334 0v42.666667h42.666666V341.333333H298.666667z m-85.333334 170.666667v42.666667h42.666667v-42.666667H213.333333z m85.333334 0v42.666667h42.666666v-42.666667H298.666667z m-85.333334 170.666667v42.666666h42.666667v-42.666666H213.333333z m85.333334 0v42.666666h42.666666v-42.666666H298.666667z m384 42.666666h42.666666v42.666667h-42.666666v-42.666667z m-85.333334 0h42.666667v42.666667h-42.666667v-42.666667z"
				      fill="#0da346" p-id="2327"></path>
				  </svg>
				</div>
				<div class="title" style="padding-left: 30px; color: #0da346;">{{$t('label_4')}}</div>
				<div class="num" style="padding-left: 30px ; color: #0da346;">{{deviceList.deviceNum}}</div>
			</div>
			<!-- <div style="display: flex;align-items: center;margin-left: 30px;">
			  <div>
			    <svg t="1689225641866" class="icon" viewBox="0 0 1024 1024" version="1.1"
			         xmlns="http://www.w3.org/2000/svg" p-id="2898" width="20" height="20">
			      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#d1d1d1"
			            p-id="2899"></path>
			    </svg>
			  </div>
			  <div class="title" style="padding-left: 30px;">{{$t('label_12')}}</div>
			  <div class="num" style="padding-left: 30px">{{deviceList.onlineNum}}</div>
			</div> -->
			<!-- <div style="display: flex;align-items: center;margin-left: 30px;">
			  <div>
			    <svg t="1689225641866" class="icon" viewBox="0 0 1024 1024" version="1.1"
			         xmlns="http://www.w3.org/2000/svg"
			         p-id="2898" width="20" height="20">
			      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#43dc7d" p-id="2899"></path>
			    </svg>
			  </div>
			  <div class="title" style="padding-left: 30px;">{{$t('label_8')}}</div>
			  <div class="num" style="color: #43dc7d;padding-left: 30px;">{{deviceList.offlineNum}}</div>
			</div> -->
			<!-- <div style="display: flex;align-items: center;margin-left: 40px;">
			  <div>
			    <svg t="1689225641866" class="icon" viewBox="0 0 1024 1024" version="1.1"
			         xmlns="http://www.w3.org/2000/svg" p-id="2898" width="10" height="10">
			      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#00d7f1"
			            p-id="2899"></path>
			    </svg>
			  </div>
			  <div class="title" style="padding-left: 30px;">{{$t('label_16')}}</div>
			  <div class="num" style="color: #00d7f1;padding-left: 30px">{{deviceList.normalNum}}</div>
			</div> -->
			<!-- <div style="display: flex;align-items: center;margin-left: 40px;">
			  <div>
			    <svg t="1689225641866" class="icon" viewBox="0 0 1024 1024" version="1.1"
			         xmlns="http://www.w3.org/2000/svg" p-id="2898" width="10" height="10">
			      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#ff3300"
			            p-id="2899"></path>
			    </svg>
			  </div>
			  <div class="title" style="padding-left: 30px;">{{$t('label_19')}}</div>
			  <div class="num" style="padding-left: 30px">{{deviceList.alarmNum}}</div>
			</div> -->
        </div>
        <div class="box2">
          <div style="display: flex;align-items: center">
          	<div>
          	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
          	       xmlns="http://www.w3.org/2000/svg"
          	       p-id="4047" width="40" height="40">
          	    <path
          	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
          	      fill="#000000" p-id="4048"></path>
          	    <path
          	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
          	      fill="#000000" p-id="4049"></path>
          	  </svg>
          	</div>
          	<div class="title" style="padding-left: 30px;">{{$t('label_21')}}</div>
          	<div class="num" style="color: #000000;padding-left: 30px;">{{this.statusList.num0}}</div>
          </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#e60000" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#e60000" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_299')}}</div>
		  	<div class="num" style="color: #e60000;padding-left: 30px;">{{this.statusList.num1}}</div>
		  </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#e60000" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#e60000" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_303')}}</div>
		  	<div class="num" style="color: #e60000;padding-left: 30px;">{{this.statusList.num2}}</div>
		  </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#e60000" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#e60000" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_307')}}</div>
		  	<div class="num" style="color: #e60000;padding-left: 30px;">{{this.statusList.num3}}</div>
		  </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#ffb400" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#ffb400" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_311')}}</div>
		  	<div class="num" style="color: #ffb400;padding-left: 30px;">{{this.statusList.num4}}</div>
		  </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#e60000" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#e60000" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_314')}}</div>
		  	<div class="num" style="color: #e60000;padding-left: 30px;">{{this.statusList.num5}}</div>
		  </div>
		  <div style="display: flex;align-items: center;margin-left: 20px;">
		  	<div>
		  	  <svg t="1689229804358" class="icon" viewBox="0 0 1024 1024" version="1.1"
		  	       xmlns="http://www.w3.org/2000/svg"
		  	       p-id="4047" width="20" height="20">
		  	    <path
		  	      d="M770.7 152.4h-96.6s-30.8 76-66.6 72.2H423.2c-35.9 3.8-66.6-72.2-66.6-72.2h-99.8c-54.3 0-98.7 45.5-98.7 101.2V827c0 55.7 44.4 101.2 98.7 101.2h514c54.2 0 98.5-45.3 98.7-100.8V253.1c-0.3-55.4-44.6-100.7-98.8-100.7z m-53.1 577.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z m0-162.3H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 14.9-12.1 27.1-27 27.1z m0-144.4H313.2c-14.9 0-26.9-12.1-26.9-27.1 0-15 12.1-27.1 26.9-27.1h404.4c14.9 0 27 12.1 27 27.1-0.1 15-12.1 27.1-27 27.1z"
		  	      fill="#ffb400" p-id="4048"></path>
		  	    <path
		  	      d="M637.3 206.5H390.1c-0.5 0-0.9-0.4-0.9-0.9V99.1c0-0.5 0.4-0.9 0.9-0.9h247.2c0.5 0 0.9 0.4 0.9 0.9v106.4c0 0.6-0.4 1-0.9 1z"
		  	      fill="#ffb400" p-id="4049"></path>
		  	  </svg>
		  	</div>
		  	<div class="title" style="padding-left: 30px;">{{$t('label_318')}}</div>
		  	<div class="num" style="color: #ffb400;padding-left: 30px;">{{this.statusList.num6}}</div>
		  </div>
        </div>
        <div class="box">
          <div class="table2" style="width: 100%; height: calc(100% - 20px); margin: 10px 10px 0 10px; background-color:transparent;">
			  <div class="dataBox">
			  	<div class="icon">
			  		<div class="set" @click="toPath('/static/deviceFilePage')">{{$t('label_690')}}</div>
			  		<div class="ban" @click="toPath('/static/malfunctionResumePage')">{{$t('label_87')}}</div>
			  		<div class="search" @click="toPath('/static/maintainResumePage')">{{$t('label_90')}}</div>
			  		<div class="check" @click="toPath('/static/InspectionRecord')">{{$t('label_102')}}</div>
			  	</div>
			  	<div class="data" style="width: 900px;height: 210px">
			  		<el-calendar>
			  			<!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
			  			<template slot="dateCell" slot-scope="{date, data}">
			  				<p :class="data.isSelected ? 'is-selected' : ''">
			  					{{data.day.split('-')[2]}}
			  				</p>
			  				<div class="iconBox">
			  					<template v-for="item in list.dayList">
			  						<template v-if="item.time == data.day">
			  							<div class="icon ban" v-if="item.repairTime > 0"></div>
			  							<div class="icon search" v-if="item.maintainTime > 0"></div>
			  							<div class="icon check" v-if="item.inspTime > 0"></div>
			  						</template>
			  					</template>
			  				</div>
			  			</template>
			  		</el-calendar>
			  	</div>
			  </div>
          	</div>
        </div>
      </div>
      <div class="conBOX">
        <div class="map-info">
          <div class="middle-layer" >
            <baidu-map v-if="$store.getters.getShowMap" class="map" :scroll-wheel-zoom="true" :center="center" :zoom="zoom" @ready="handler">
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              <bm-marker style="background-color: #00ff00; color: #00ff00" v-for="(item, index) in mapList"
                         :position="item" shape="BMAP_POINT_SHAPE_WATERDROP" :key="index" @click="clickHandler(item)"
                         :icon="makeIcon(item.markerColor)">
              </bm-marker>
              <bm-info-window :position="marker" :show="show" :closeOnClick="true" style="font-size: 14px">
                <p>{{$t('label_872')}}: {{ selectMapPoint.customerName }}</p>
                <p>{{$t('label_873')}}: {{ selectMapPoint.address }}</p>
                <p>{{$t('label_874')}}: {{ selectMapPoint.alarmCount }}</p>
                <p>{{$t('label_875')}}: {{ selectMapPoint.offLine }}</p>
                <p>{{$t('label_876')}}: {{ selectMapPoint.defectCount }}</p>
                <p>{{$t('label_877')}}: {{ selectMapPoint.controllerCount }}</p>
                <p>{{$t('label_43')}}: {{ selectMapPoint.detectorCount }}</p>

                <template>
                  <p v-for="item in selectMapPoint.probeInfos">{{ item }}</p>
                </template>

              </bm-info-window>
            </baidu-map>
            <el-table
              v-if="!$store.getters.getShowMap"
              ref="singleTable"
              :data="tableData"
              highlight-current-row
              @current-change="handleCurrentChange"
              border
              style="width: 100%;"
              height="555"
              :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
              <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
              </el-table-column>
              <el-table-column prop="customerName" :label="$t('label_857')" align="center">
              </el-table-column>
              <el-table-column prop="deviceName" :label="$t('label_429')" align="center">
              </el-table-column>
              <el-table-column prop="code" :label="$t('label_194')" align="center">
              </el-table-column>
              <el-table-column prop="address" :label="$t('label_36')" align="center">
              </el-table-column>
              <el-table-column prop="autoFlag" :label="$t('label_784')" align="center">
                <template slot-scope="scope">
                  <template v-if="scope.row.autoFlag == '1'">{{$t('label_454')}}</template>
                  <template v-if="scope.row.autoFlag == '0'">{{$t('label_458')}}</template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import "@/assets/css/map/map.css";
  import "@/assets/css/common/spot.css";
  import MapJs from "@/assets/js/map/map.js";
  import tree from "@/components/list/tree/checkTree";
  import common from "@/assets/js/common/common.js";
  import calendar from "@/components/list/calendar/calendar";
  import utils from '@/utils/utils';
  import signal from "@/assets/js/signal/signal.js";
  import Malfunction from "@/assets/js/malfunction/malfunction.js";

  export default {
    name: "taskMap",
    components: {
      tree,
    },
    data() {
      return {
        center: {
          //lng: "121.607",
          //lat: "38.96",
          lng: "121.64",
          lat: "38.85",
        },
        zoom: 12,
        activeNameTree: 'second',
        treeShow: true,
        tableData: [],
        treeData: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: false,
          dataAll: true,
          funtoGetMes: '2',
        },
        treeData2: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: false,
          dataAll: true,
          funtoGetMes: '3'
        },
        mapList: [],
        marker: {
          //lng: 121.607,
          //lat: 38.96,
          lng: 121.48789,
          lat: 31.24916,
        },
        show: false,
        deviceDialog: false,
        statisticAll: {
          allTime: "",
          allCompletion: "",
          todayTime: "",
          todayCompletion: "",
        },
        selectMapPoint: {
          customerName: "",
          address: "",
          offLine: "",
          alarmCount: "",
          defectCount: "",
          controllerCount: "",
          detectorCount: "",
          probeInfos: [],
        },
        areaName: "",
        statisticCity: [],
		pageNum: 1,
		pageSize: 10,
		pageCount: 0,
		list: [],
		width: '340px',
		qrCodeShow: false,
		deviceList: {
			deviceNum: 0,
			onlineNum: 0,
			offlineNum: 0,
			alarmNum: 0,
			normalNum: 0
		},
		statusList: {
			num0: '',
			num1: '',
			num2: '',
			num3: '',
			num4: '',
			num5: '',
			num6: ''
		},
		equipmentList: [],
      };
    },
    watch: {
      msg: function (newVal, oldVal) {
        // TO DO
        console.log("newVal:", newVal);
        console.log("oldVal:", oldVal);
      },
    },
    methods: {
	  getIndex(index) {
	    return (this.pageNum - 1) * this.pageSize + index + 1
	  },
      makeIcon(r) {
        if (r == "r") {
          return {
            url: "https://www.sfrsafety.com/static/img/marker-" + r + ".gif",
            size: {
              width: 32,
              height: 32,
            },
          };
        } else {
          return {
            url: "https://www.sfrsafety.com/static/img/marker-" + r + ".png",
            size: {
              width: 32,
              height: 32,
            },
          };
        }
      },

      handler() {

      },

      handleClickTree(tab, event) {
        this.getTreeMes = '0';
        this.searchDataList = {}
        this.deviceDetailMes = {}
        this.deviceDetailMes.name = this.$t('label_272')
      },
      getDeviceMes(data) {
		if (data.name == this.$t('label_272')) {
			this.getTreeMes = '0';
			this.searchDataList = {}
			this.deviceDetailMes = {}
			this.deviceDetailMes.name = this.$t('label_272')
			this.deviceDetailMes.type = 2;
			this.deviceDetailMes.id = 0;
		} else {
			this.deviceDetailMes = data;
			if (data.type == '1') {
				this.getTreeMes = '3';
				this.searchDataList = {
					infoId: data.id
				}
			} else if (data.type == '2') {
				this.getTreeMes = '0';
				this.searchDataList = {
					areaId: data.id
				}
			} else if (data.type == '0') {
				this.getTreeMes = '0';
				this.searchDataList = {
					deviceId: data.id
				}
			}
		}
		this.search();
		this.selectEquipmentById();
		this.searchStauts();
      },
	  search() {
		  var dataParam = this.searchDataList;
		  this.getCustomerInfoList(dataParam);
	  },
	  getCustomerInfoList(param) {
		common.getCustomerInfoList(param).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				this.tableData = data.data;
			}
		}).catch((response) => {
			console.log(response)
		})
	  },
	  searchStauts() {
		let param = {};
		if (this.deviceDetailMes.id == 0) {
			param = {
				id: this.deviceDetailMes.id,
				status: ["1", "2", "3", "4", "5", "6", "7", "8"],
				urgentLevel: [],
				urgentLevel1: []
			}
		} else {
			param = {
				id: this.deviceDetailMes.id,
				type: this.deviceDetailMes.type,
				status: ["1", "2", "3", "4", "5", "6", "7", "8"],
				urgentLevel: [],
				urgentLevel1: []
			}
		}
	  	Malfunction.getRecordStatus(param, true).then((response) => {
	  		const data = response.data;
	  		if (data.code == "1") {
	  			this.statusList.num0 = data.data.num1 + data.data.num2 + data.data.num3 + data.data.num4 + data.data.num5 + data.data.num6;
	  			this.statusList.num1 = data.data.num1;
	  			this.statusList.num2 = data.data.num2;
	  			this.statusList.num3 = data.data.num3;
	  			this.statusList.num4 = data.data.num4;
	  			this.statusList.num5 = data.data.num5;
	  			this.statusList.num6 = data.data.num6;
	  		}
	  	}).catch((response) => {
	  		console.log(response)
	  	})
	  },
	  selectEquipmentById() {
		let param = {
			id: this.deviceDetailMes.id,
			type: this.deviceDetailMes.type,
			sortName: 'code',
			sort: 'ASC'
		}
		signal.selectEquipmentById(param).then((response) => {
			let data = response.data;
			if (data.code == "1") {
				console.log(data.data);
				this.deviceList.offlineNum = 0;
				this.deviceList.onlineNum = 0;
				this.deviceList.deviceNum = 0;
				if (data.data.length > 0) {
					this.deviceList.deviceNum = data.data.length;
					for (var i = 0; i < data.data.length; i++) {
						if (data.data[i].autoFlag == 1) {
							this.deviceList.offlineNum = this.deviceList.offlineNum + 1;
						} else {
							this.deviceList.onlineNum = this.deviceList.onlineNum + 1;
						}
					}
				}
				this.selectSignal();
				this.equipmentList = data.data;
				// this.addequipmentList();
				// this.selectEfficency();
				// this.selectSignal();
			}
		}).catch((response) => {
			console.log(response)
		})
	  },
	  //信号灯数据
	  selectSignal() {
	  	signal.selectSignal(this.equipmentList).then((response) => {
	  		let data = response.data;
	  		if (data.code == "1") {
	  			if (data.data.length > 0) {
					// for (let i = 0; i < data.data.length; i++) {
					// 	if (data.data[i].) {

					// 	}
					// }
				}
	  		}
	  	}).catch((response) => {
	  		console.log(response)
	  	})
	  },
      getNowTime() {
        let zeroTime = new Date();
        let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
        let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
        let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
        return now;
      },
      clickHandler(e) {
        this.show = true;
        let param = {
          customerId: e.customerId
        };
        MapJs.getMapListByCustomerId(param)
          .then((response) => {
            const data = response.data;
            console.log(data);
            if (data.code == 1) {
              this.marker = {
                lng: data.data.lng,
                lat: data.data.lat,
              };
              console.log("12312:" + JSON.stringify(data.data.probeInfos));
              this.selectMapPoint = {
                customerName: data.data.customerName,
                address: data.data.address,
                offLine: data.data.offLine,
                alarmCount: data.data.alarmCount,
                defectCount: data.data.defectCount,
                controllerCount: data.data.controllerCount,
                detectorCount: data.data.detectorCount,
                probeInfos: data.data.probeInfos,
              };
              console.log("输出：" + JSON.stringify(selectMapPoint));
            }
          })
          .catch((response) => {
          });
      },
      getStatisticAll(item) {
        for (let a in item) {
          if (Array.isArray(item[a])) {
            item[a] = item[a][0];
          } else if (item[a] == "all") {
            item = {
              city: null,
            };
          }
        }
        MapJs.getStatisticAll(item)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.statisticAll = data.data;
            }
          })
          .catch((response) => {
          });
      },
      queryArea(item, lng, lat) {
        if (item == "all") {
          item = {
            city: "all",
          };
        }
        this.areaName = item;
        this.getMapList(item);
        this.getDeviceInfo(item);

        if (item.city != "all" && item.city != undefined) {
          var $this = this
          var myGeo = new BMap.Geocoder();
          myGeo.getPoint(item.city, function (point) {
            $this.center.lng = point.lng
            $this.center.lat = point.lat
            $this.zoom = 12
          }, item.city)
        } else {
          this.center.lng = lng;
          this.center.lat = lat;
        }

        this.getStatisticAll(item);
      },
      getDeviceInfo(item) {
        MapJs.getStatisticCity(item)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.statisticCity = data.data;
            }
          })
          .catch((response) => {
          });
      },

      getMapList(item) {
        if (item == "all") {
          item = "";
        }
        MapJs.getMapList(item)
          .then((response) => {
            const data = response.data;
            if (data.code == 1) {
              this.mapList = data.data;
            }
          })
          .catch((response) => {
          });
      },
	  handleCurrentChange(info) {

	  },
	  homePage(param) {
	  	common.homePage(param).then((response) => {
	  		const data = response.data;
	  		if (data.code == "1") {
	  			this.list = data.data
	  		}
	  	}).catch((response) => {
	  		console.log(response)
	  	})
	  },
	  toPath(key) {
	  	test2(key)
	  },
	  showBtn() {
	  	this.qrCodeShow = !this.qrCodeShow;
	  	if (this.qrCodeShow) {
	  		this.width = "0px";
	  	} else {
	  		this.width = "340px";
	  	}
	  },
    },
    created() {
      /*this.getStatisticAll({
        city: "all",
      });*/
      //this.queryArea("all", "121.607", "38.96");
	  this.day = utils.getNowFormatDate().substring(0, 7);
	  this.homePage(this.day);
      // this.queryArea("all", "139.6917", "35.6895");
    },
  };
</script>
<style>
  .conBOX {
    width: 100%;
    height: calc(100% - 145px);
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 10px 10px;
  }

  .alarm-info {
    width: 100%;
	height: 400px;
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 10px;
  }

  .alarm-info .box {
    background: #ffffff;
    width: 49%;
    padding: 20px;
  }


  .alarm-info .box .title {
    font-size: 18px;
    font-weight: bold;
    color: #d1d1d1;
  }

  .alarm-info .box .title svg {
    padding-right: 10px;
    margin: -7px 0px;
  }

  .alarm-info .box .num {
    font-size: 28px;
    font-weight: bold;
    color: #d1d1d1;
    padding-left: 10px;
  }

  .alarm-info .box .mes {
    display: flex;
    padding-left: 10px;
    justify-content: space-between;
    align-items: center;
  }

  .alarm-info .box .mes .right {
    display: flex;
    align-items: center;
    text-align: right;
  }

  .alarm-info .box .mes .right .title {
    font-size: 15px;
  }

  .alarm-info .box .mes .right .num {
    font-size: 20px;
  }

  .alarm-info .box2 {
    background: #ffffff;
    width: 25%;
    padding: 20px;
  }

  .alarm-info .box2 .title {
    font-size: 18px;
    font-weight: bold;
    color: #d1d1d1;
	width: 180px;
  }

  .alarm-info .box2 .title svg {
    padding-right: 10px;
    margin: -7px 0px;
  }

  .alarm-info .box2 .num {
    font-size: 28px;
    font-weight: bold;
    color: #d1d1d1;
    padding-left: 10px;
  }

  .alarm-info .box2 .mes {
    display: flex;
    padding-left: 10px;
    justify-content: space-between;
    align-items: center;
  }

  .alarm-info .box2 .mes .right {
    display: flex;
    align-items: center;
    text-align: right;
  }

  .alarm-info .box2 .mes .right .title {
    font-size: 15px;
  }

  .alarm-info .box2 .mes .right .num {
    font-size: 20px;
  }

  .map-info {
    height: 100%;
    width: 100%;
  }

  .customer-info {
    width: 25%;
  }

  .device-info {
    height: 100%;
    width: 25%;
    margin-left: 10px;
    overflow: hidden;
  }

  .info-list {
    overflow: hidden;
  }

  .info-list .treeNoChoose .selectSpot2 .el-tree {
    background: none;
  }

  .info-list .el-tree {
    color: #000000;
  }

  .info-list .el-tree-node__content:hover {
    background-color: #ffffff;
  }

  .info-list .treeNoChoose .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ffffff;
  }

  .info-list .treeNoChoose .selectSpot2 {
    background: none;
  }

  .device-info {
  }

  .device-info .customerBox {
    background-color: #ffffff;
    padding: 10px 10px 10px 0;
  }

  .device-info .customerBox .title {
    border: 4px solid #ffffff;
    border-left: 8px solid #43dc7d;
    padding-left: 10px;
    color: #000000;
    margin-bottom: 10px;
  }

  .device-info .customerBox .mes {
    padding-left: 20px;
    color: #000000;
    margin-bottom: 5px;
  }

  .device-info .customerBox .box {
    background-color: #E2E2E2;
    margin: 10px 20px 10px 20px;
    padding: 10px;
    color: #000000;
  }

  .device-info .customerBox .box .boxMes {
    margin-bottom: 10px;
  }

  .device-info .deviceBox {
    margin-top: 10px;
    width: 100%;
    height: calc(100% - 270px);
    background-color: #ffffff;
    padding: 10px 10px 10px 0;
  }

  .device-info .deviceBox .title {
    border: 4px solid #ffffff;
    border-left: 8px solid #43dc7d;
    padding-left: 10px;
    color: #000000;
    margin-bottom: 10px;
  }

  .device-info .deviceBox .deviceList {
    width: 100%;
    height: calc(100% - 50px);
    overflow: auto;
    padding: 20px;
  }

  .device-info .deviceBox .deviceList .list {
    border-bottom: 2px solid #858995;
    margin-bottom: 15px;
    position: relative;
    height: auto;
    padding: 0;
  }

  .device-info .deviceBox .deviceList .nameBox {
    color: #000000;
  }

  .device-info .deviceBox .box {
    background-color: #E2E2E2;
    margin: 10px 20px 20px 20px;
    padding: 10px;
    color: #000000;
    cursor: pointer;
    border: 2px solid #E2E2E2;
  }

  .device-info .deviceBox .box:hover {
    border: 2px solid #43dc7d;
  }

  .dialogBoxdetail .el-dialog__header {
    background: #ffffff;
    text-align: center;
    font-weight: bold;
  }

  .dialogBoxdetail .el-dialog__title {
    color: #000000;
  }

  .dialogBoxdetail .el-dialog__body, .dialogBoxdetail .el-dialog__footer {
    background: #ffffff;
  }

  .dialogBoxdetail .dialogBoxMes .grid-content {
    color: #333333;
    font-weight: bold;
  }

  .dialogBoxdetail .dialogBoxMes .grid-content span {
    color: #333333;
    font-weight: normal;
  }

  .tableMessss {
    display: flex;
    width: 100%;
    justify-content: space-around;
    padding: 20px 0;
  }

  .tableMessss .table {
    margin-bottom: 20px;
  }

  .tableMessss .title {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    margin-bottom: 10px;
  }

  .tableMessss .table .mes {
    display: flex;
  }

  .tableMessss .table .name {
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    background: #2bbd87;
    width: 140px;
    line-height: 40px;
    margin-bottom: 1px;
  }

  .tableMessss .table .status {
    color: #ff0204;
    font-weight: bold;
    text-align: center;
    background: #f7f7f7;
    width: 140px;
    line-height: 40px;
    margin-bottom: 1px;
    margin-left: 1px;
  }

  .tableMessss .el-table th, .tableMessss .el-table tr {
    background: #f7f7f7 ;
    color: #333333;
  }

  .tableMessss .el-table td, .tableMessss .el-table th.is-leaf {
    border-bottom: 1px solid #ffffff;
  }

  .tableMessss .el-table--border::after, .tableMessss .el-table--group::after, .tableMessss .el-table::before {
    background-color: #ffffff;
  }

  .tableMessss .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #ffffff;
  }
  .table2 .dataBox {
  	width: 100%;
  	height: 100%;
  	overflow: hidden;
  	display: flex;
  }

  .table2 .dataBox .icon {
  	width: calc(100% - 300px);
  	display: flex;
  	justify-content: space-between;
  	flex-wrap: wrap;
  	padding: 20px 0;
  }

  .table2 .dataBox .icon div {
  	font-size: 13px;
  	padding-top: 50px;
  	width: 50%;
  	margin: 20px 0 0 0;
  	text-align: center;
  }

  .table2 .data .iconBox .icon{
    width: 20px;
    height: 20px;
  }

  .table2 .el-calendar-table .el-calendar-day{
  	height: 43px;
  	font-size: 12px;
  	padding: 2px;
  	text-align: center;
  }

  .right-showbtn-qrcode-background {
  	/* position: absolute; */
  	width: 10px;
  	height: 80px;
  	background-color: #9c9c9c;
  	border-top-right-radius: 10px;
  	border-bottom-right-radius: 10px;
  	margin: auto;
  }
  .right-showbtn {
  	width: 10px;
  	height: 100%;
  	display: flex;
  	position: relative;
  	z-index: 100000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/homepage/taskMap.vue